import { useState } from 'react';
import Layout from '../../../components/layout/Layout';

export default function GamificacaoAnalytics() {
  const [periodo, setPeriodo] = useState('mes');

  // XP distribuído por campanha
  const xpPorCampanha = [
    { campanha: 'Campanha Verão 2024', xp_total: 345890, participantes: 456, media_xp: 758 },
    { campanha: 'Mega Vendas Q1', xp_total: 298450, participantes: 389, media_xp: 767 },
    { campanha: 'Ativação Premium', xp_total: 234560, participantes: 312, media_xp: 752 },
    { campanha: 'Serviços Plus', xp_total: 189340, participantes: 267, media_xp: 709 },
  ];

  // Missões mais concluídas
  const missoesMaisConcluidas = [
    { missao: 'Vendedor Estrela', conclusoes: 567, xp_total: 283500, taxa_sucesso: '78%' },
    { missao: 'Mestre dos Serviços', conclusoes: 456, xp_total: 342000, taxa_sucesso: '65%' },
    { missao: 'Ativador Premium', conclusoes: 389, xp_total: 389000, taxa_sucesso: '82%' },
    { missao: 'Suporte 5 Estrelas', conclusoes: 678, xp_total: 203400, taxa_sucesso: '91%' },
  ];

  // Ranking XP
  const rankingXP = [
    { posicao: 1, participante: 'João Silva', xp_total: 52340, nivel: 'Diamante', distintivos: 12 },
    { posicao: 2, participante: 'Maria Santos', xp_total: 48920, nivel: 'Platina', distintivos: 10 },
    { posicao: 3, participante: 'Pedro Costa', xp_total: 45670, nivel: 'Platina', distintivos: 9 },
    { posicao: 4, participante: 'Ana Oliveira', xp_total: 42150, nivel: 'Ouro', distintivos: 8 },
    { posicao: 5, participante: 'Carlos Souza', xp_total: 39840, nivel: 'Ouro', distintivos: 7 },
  ];

  // Participação por jogo
  const participacaoPorJogo = [
    { jogo: 'Roleta de Prêmios', participacoes: 1234, xp_gasto: 61700, xp_ganho: 89450, saldo: 27750 },
    { jogo: 'Bingo', participacoes: 987, xp_gasto: 98700, xp_ganho: 145600, saldo: 46900 },
    { jogo: 'Raspadinha', participacoes: 876, xp_gasto: 26280, xp_ganho: 34890, saldo: 8610 },
    { jogo: 'Rifa', participacoes: 654, xp_gasto: 13080, xp_ganho: 45600, saldo: 32520 },
    { jogo: 'Palpites da Copa', participacoes: 570, xp_gasto: 5700, xp_ganho: 12450, saldo: 6750 },
  ];

  // Geração de XP por venda/serviço
  const geracaoXP = [
    { tipo: 'Venda de Produtos', quantidade: 2345, xp_gerado: 234500, ticket_medio: 100 },
    { tipo: 'Prestação de Serviços', quantidade: 1567, xp_gerado: 235050, ticket_medio: 150 },
    { tipo: 'Ativação de Clientes', quantidade: 892, xp_gerado: 178400, ticket_medio: 200 },
    { tipo: 'Atendimento e Suporte', quantidade: 3456, xp_gerado: 172800, ticket_medio: 50 },
  ];

  // Engajamento por região/equipe
  const engajamentoPorRegiao = [
    { regiao: 'São Paulo', participantes: 234, xp_total: 456780, missoes: 1234, jogos: 890 },
    { regiao: 'Rio de Janeiro', participantes: 189, xp_total: 378920, missoes: 987, jogos: 654 },
    { regiao: 'Minas Gerais', participantes: 156, xp_total: 312450, missoes: 765, jogos: 543 },
    { regiao: 'Paraná', participantes: 134, xp_total: 267890, missoes: 654, jogos: 432 },
  ];

  // Resgates com XP
  const resgatesXP = [
    { produto: 'Mouse Logitech MX Master 3', resgates: 89, xp_total: 44500, valor_medio: 500 },
    { produto: 'Teclado Mecânico Keychron K2', resgates: 67, xp_total: 53600, valor_medio: 800 },
    { produto: 'Webcam Logitech C920', resgates: 54, xp_total: 27000, valor_medio: 500 },
    { produto: 'Fone de Ouvido Sony WH-1000XM4', resgates: 43, xp_total: 51600, valor_medio: 1200 },
  ];

  // Curva de evolução
  const curvaEvolucao = [
    { mes: 'Jan', participantes_bronze: 456, participantes_prata: 234, participantes_ouro: 123, participantes_platina: 67, participantes_diamante: 23 },
    { mes: 'Fev', participantes_bronze: 423, participantes_prata: 267, participantes_ouro: 145, participantes_platina: 78, participantes_diamante: 25 },
    { mes: 'Mar', participantes_bronze: 389, participantes_prata: 298, participantes_ouro: 167, participantes_platina: 89, participantes_diamante: 28 },
  ];

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Analytics & Engajamento</h1>
            <p className="text-sm text-gray-600 mt-1">Análise de desempenho e engajamento da gamificação</p>
          </div>
          <div className="flex items-center gap-3">
            <select
              value={periodo}
              onChange={(e) => setPeriodo(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
            >
              <option value="hoje">Hoje</option>
              <option value="semana">Esta Semana</option>
              <option value="mes">Este Mês</option>
              <option value="trimestre">Trimestre</option>
              <option value="ano">Ano</option>
            </select>
            <button className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-sm font-medium whitespace-nowrap">
              <i className="ri-download-line mr-2"></i>
              Exportar Relatório
            </button>
          </div>
        </div>

        {/* XP Distribuído por Campanha */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h2 className="text-lg font-bold text-gray-900 mb-4">XP Distribuído por Campanha</h2>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Campanha</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">XP Total</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Participantes</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Média XP</th>
                </tr>
              </thead>
              <tbody>
                {xpPorCampanha.map((item, index) => (
                  <tr key={index} className="border-t border-gray-100 hover:bg-gray-50">
                    <td className="py-3 px-4 text-sm font-medium text-gray-900">{item.campanha}</td>
                    <td className="py-3 px-4 text-center text-sm font-bold text-yellow-600">{item.xp_total.toLocaleString('pt-BR')} XP</td>
                    <td className="py-3 px-4 text-center text-sm text-gray-700">{item.participantes}</td>
                    <td className="py-3 px-4 text-center text-sm font-bold text-teal-600">{item.media_xp} XP</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Missões Mais Concluídas e Ranking XP */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Missões Mais Concluídas */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-bold text-gray-900 mb-4">Missões Mais Concluídas</h2>
            <div className="space-y-3">
              {missoesMaisConcluidas.map((missao, index) => (
                <div key={index} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                  <div className="flex items-center justify-between mb-2">
                    <p className="text-sm font-semibold text-gray-900">{missao.missao}</p>
                    <span className="inline-flex items-center px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs font-medium">
                      {missao.taxa_sucesso}
                    </span>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <p className="text-xs text-gray-600">Conclusões</p>
                      <p className="text-sm font-bold text-teal-600">{missao.conclusoes}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-600">XP Total</p>
                      <p className="text-sm font-bold text-yellow-600">{missao.xp_total.toLocaleString('pt-BR')} XP</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Ranking XP */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-bold text-gray-900 mb-4">Ranking XP - Top 5</h2>
            <div className="space-y-3">
              {rankingXP.map((item) => (
                <div key={item.posicao} className="flex items-center gap-4 bg-gray-50 rounded-lg p-4 border border-gray-200">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-white ${
                    item.posicao === 1 ? 'bg-yellow-500' :
                    item.posicao === 2 ? 'bg-gray-400' :
                    item.posicao === 3 ? 'bg-orange-600' :
                    'bg-gray-300'
                  }`}>
                    {item.posicao}º
                  </div>
                  <div className="flex-1">
                    <p className="text-sm font-semibold text-gray-900">{item.participante}</p>
                    <p className="text-xs text-gray-600 mt-1">
                      {item.nivel} • {item.distintivos} distintivos
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-bold text-yellow-600">{item.xp_total.toLocaleString('pt-BR')}</p>
                    <p className="text-xs text-gray-600">XP</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Participação por Jogo */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Participação por Jogo</h2>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Jogo</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Participações</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">XP Gasto</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">XP Ganho</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Saldo</th>
                </tr>
              </thead>
              <tbody>
                {participacaoPorJogo.map((jogo, index) => (
                  <tr key={index} className="border-t border-gray-100 hover:bg-gray-50">
                    <td className="py-3 px-4 text-sm font-medium text-gray-900">{jogo.jogo}</td>
                    <td className="py-3 px-4 text-center text-sm text-gray-700">{jogo.participacoes}</td>
                    <td className="py-3 px-4 text-center text-sm font-bold text-red-600">{jogo.xp_gasto.toLocaleString('pt-BR')} XP</td>
                    <td className="py-3 px-4 text-center text-sm font-bold text-green-600">{jogo.xp_ganho.toLocaleString('pt-BR')} XP</td>
                    <td className="py-3 px-4 text-center text-sm font-bold text-teal-600">+{jogo.saldo.toLocaleString('pt-BR')} XP</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Geração de XP e Engajamento por Região */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Geração de XP por Venda/Serviço */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-bold text-gray-900 mb-4">Geração de XP por Tipo</h2>
            <div className="space-y-3">
              {geracaoXP.map((item, index) => (
                <div key={index} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                  <div className="flex items-center justify-between mb-2">
                    <p className="text-sm font-semibold text-gray-900">{item.tipo}</p>
                    <span className="text-xs font-bold text-yellow-600">{item.ticket_medio} XP médio</span>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <p className="text-xs text-gray-600">Quantidade</p>
                      <p className="text-sm font-bold text-gray-900">{item.quantidade}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-600">XP Gerado</p>
                      <p className="text-sm font-bold text-teal-600">{item.xp_gerado.toLocaleString('pt-BR')} XP</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Engajamento por Região */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-bold text-gray-900 mb-4">Engajamento por Região</h2>
            <div className="space-y-3">
              {engajamentoPorRegiao.map((regiao, index) => (
                <div key={index} className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                  <p className="text-sm font-semibold text-gray-900 mb-2">{regiao.regiao}</p>
                  <div className="grid grid-cols-4 gap-2">
                    <div>
                      <p className="text-xs text-gray-600">Participantes</p>
                      <p className="text-sm font-bold text-gray-900">{regiao.participantes}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-600">XP Total</p>
                      <p className="text-sm font-bold text-yellow-600">{regiao.xp_total.toLocaleString('pt-BR')}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-600">Missões</p>
                      <p className="text-sm font-bold text-purple-600">{regiao.missoes}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-600">Jogos</p>
                      <p className="text-sm font-bold text-blue-600">{regiao.jogos}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Resgates com XP */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Produtos Mais Resgatados com XP</h2>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Produto</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Resgates</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">XP Total</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Valor Médio</th>
                </tr>
              </thead>
              <tbody>
                {resgatesXP.map((produto, index) => (
                  <tr key={index} className="border-t border-gray-100 hover:bg-gray-50">
                    <td className="py-3 px-4 text-sm font-medium text-gray-900">{produto.produto}</td>
                    <td className="py-3 px-4 text-center text-sm text-gray-700">{produto.resgates}</td>
                    <td className="py-3 px-4 text-center text-sm font-bold text-yellow-600">{produto.xp_total.toLocaleString('pt-BR')} XP</td>
                    <td className="py-3 px-4 text-center text-sm font-bold text-teal-600">{produto.valor_medio} XP</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Curva de Evolução dos Participantes */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Curva de Evolução dos Participantes</h2>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Mês</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Bronze</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Prata</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Ouro</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Platina</th>
                  <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Diamante</th>
                </tr>
              </thead>
              <tbody>
                {curvaEvolucao.map((item, index) => (
                  <tr key={index} className="border-t border-gray-100 hover:bg-gray-50">
                    <td className="py-3 px-4 text-sm font-medium text-gray-900">{item.mes}</td>
                    <td className="py-3 px-4 text-center text-sm font-bold" style={{ color: '#CD7F32' }}>{item.participantes_bronze}</td>
                    <td className="py-3 px-4 text-center text-sm font-bold" style={{ color: '#C0C0C0' }}>{item.participantes_prata}</td>
                    <td className="py-3 px-4 text-center text-sm font-bold" style={{ color: '#FFD700' }}>{item.participantes_ouro}</td>
                    <td className="py-3 px-4 text-center text-sm font-bold" style={{ color: '#E5E4E2' }}>{item.participantes_platina}</td>
                    <td className="py-3 px-4 text-center text-sm font-bold" style={{ color: '#B9F2FF' }}>{item.participantes_diamante}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
}
